import { whyChooseUs } from '../mockData';
import { ShieldCheck, MapPin, Building, Handshake, TrendingUp, Headphones } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  'shield-check': ShieldCheck,
  'map-pin': MapPin,
  'building': Building,
  'handshake': Handshake,
  'trending-up': TrendingUp,
  'headphones': Headphones
};

export const WhyChooseUs = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Vrindavan Calling
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your trusted partner for secure and profitable real estate investment in Vrindavan
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card 
                key={index} 
                className="border-2 border-gray-100 hover:border-orange-300 transition-all duration-300 hover:shadow-lg group cursor-pointer"
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                    <IconComponent className="w-6 h-6 text-orange-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};